<template>
  <div class="leadgen-form-leads-header-component flex flex-col gap-3">
    <dl class="m-0 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm">
      <div class="flex items-center gap-1.5">
        <dt class="font-semibold text-foreground">{{ tr('Form ID') }}:</dt>
        <dd class="m-0 text-muted-foreground">
          <ui-skeleton v-if="!leadgenForm" class="h-3.5 w-28" />
          <template v-else>{{ leadgenForm.external_id }}</template>
        </dd>
      </div>
      <span class="text-muted-foreground" aria-hidden="true">•</span>
      <div class="flex items-center gap-1.5">
        <dt class="font-semibold text-foreground">{{ tr('Leads Count') }}:</dt>
        <dd class="m-0 text-muted-foreground tabular-nums">
          <ui-skeleton v-if="!leadgenForm || isRefreshing" class="h-3.5 w-10" />
          <template v-else>
            {{ formatNumber(leadgenForm.leads_count_by_campaigns !== null ? leadgenForm.leads_count_by_campaigns : leadgenForm.leads_count) }}
          </template>
        </dd>
      </div>
      <span class="text-muted-foreground" aria-hidden="true">•</span>
      <div class="flex items-center gap-1.5">
        <dt class="font-semibold text-foreground">{{ tr('Last Fetch') }}:</dt>
        <dd class="m-0 text-muted-foreground">
          <ui-skeleton v-if="!leadgenForm || isRefreshing" class="h-3.5 w-24" />
          <span
            v-else-if="leadgenForm.leads_fetched_at"
            v-tooltip="formatToYMD(leadgenForm.leads_fetched_at) + '. ' + formatTime(leadgenForm.leads_fetched_at)"
          >
            {{ timeAgo(leadgenForm.leads_fetched_at, tr) }}
          </span>
        </dd>
      </div>
    </dl>

    <div class="flex flex-wrap items-center gap-2">
      <refresh-button
        :label="tr('Refresh')"
        :success-message="tr('Leads refreshed successfully.')"
        :promise="handleRefresh"
      />
      <ui-button
        variant="outline"
        size="xs"
        :disabled="isDownloading || isRefreshing"
        @click="handleDownload"
      >
        <loader-circle-icon v-if="isDownloading" class="animate-spin" />
        <download-icon v-else />
        {{ tr('Download') }}
      </ui-button>
      <ui-button
        variant="outline"
        size="xs"
        :disabled="!leadgenForm"
        @click="() => openSettingsModal()"
      >
        <settings-icon />
        {{ tr('Settings') }}
      </ui-button>
      <ui-button
        v-if="showViewAllLeads"
        variant="outline"
        size="xs"
        as-child
      >
        <router-link :to="'/leadgen-forms/' + leadgenFormId">
          <inbox-icon />
          {{ tr('View all leads') }}
          ({{ formatNumber(leadgenForm.leads_count) }})
        </router-link>
      </ui-button>
    </div>
  </div>
</template>

<script>
import {
  Download,
  Inbox,
  LoaderCircle,
  Settings,
} from '@lucide/vue';

import LeadgenFormSettingsModalContent from '@/ui/components/LeadgenFormSettingsModalContent.vue';
import RefreshButton from '@/ui/components/RefreshButton.vue';
import { formatTime, formatToYMD, timeAgo } from '@/utils/date.js';
import { formatNumber } from '@/utils/number.js';

export default {
  name: 'LeadgenFormLeadsHeader',
  components: {
    DownloadIcon: Download,
    InboxIcon: Inbox,
    LoaderCircleIcon: LoaderCircle,
    RefreshButton,
    SettingsIcon: Settings,
  },
  props: {
    listComponent: {
      type: Object,
      required: true,
    },
  },
  computed: {
    leadgenFormId() {
      return this.listComponent.leadgenFormId;
    },
    leadgenForm() {
      return this.listComponent.leadgenForm;
    },
    isRefreshing() {
      return this.listComponent.isRefreshing;
    },
    isDownloading() {
      return this.listComponent.isDownloading;
    },
    showViewAllLeads() {
      return !!this.listComponent.campaignIds;
    },
  },
  methods: {
    timeAgo,
    formatNumber,
    formatToYMD,
    formatTime,
    handleRefresh() {
      return this.listComponent.refresh();
    },
    handleDownload() {
      this.listComponent.download();
    },
    openSettingsModal() {
      this.$fullscreenModal.open(
        this,
        LeadgenFormSettingsModalContent,
        { leadgenForm: this.leadgenForm },
      );
    },
  },
};
</script>
